import React from 'react';
import Icon from '@/components/ui/Icon';
import { COLORS } from '@/components/ui/ui.constants';
import { Color } from '../../types';

interface Props {
  checked?: boolean;
  borderColor?: Color;
}

const Status = ({ checked, borderColor = Color.PURPLE }: Props) => {
  if (checked) return <Icon className="tw-text-green" icon="Confirmation" size={16} />;

  return <Icon fill="none" icon="Circle" size={13.33} stroke={COLORS['tci-purple']} strokeWidth={1} />;
};

export default Status;
